import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=cd23fd04&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd23fd04')) {
      api.createRecord('cd23fd04', component.options)
    } else {
      api.reload('cd23fd04', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=cd23fd04&", function () {
      api.rerender('cd23fd04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v3U4B2qSjxGw/JS/cancellationPolicy.vue"
export default component.exports